import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { EnumeratePipe } from 'app/enurable.pipe';
import { flightClass, flightFareType } from 'app/utils/const';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { ToasterService } from 'app/services/toaster.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonUtils } from 'app/utils/commonutils';

@Component({
  selector: 'app-travellers-class',
  templateUrl: './travellers-class.component.html',
  standalone: true,
  imports: [
    EnumeratePipe,
    FormsModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatRadioModule,
    CommonModule,
    MatTooltipModule
  ]
})
export class TravellersClassComponent {

  flightClass = flightClass;
  flightFareType = flightFareType;

  /**
   * Initializes the component within a Material dialog and wires dependencies and initial data.
   *
   * @param matDialogRef Reference to the dialog instance that hosts this component; used to control or close the dialog.
   * @param alertService Service for showing toast notifications to the user.
   * @param data Initial and mutable state containing traveller counts (adult, child, infant) and related selections.
   * @returns void
   */
  constructor(
    public matDialogRef: MatDialogRef<TravellersClassComponent>,
    private alertService: ToasterService,
    @Inject(MAT_DIALOG_DATA) public data: any = {}
  ) { }

  /**
   * HostListener to detect window resize events and close the dialog when switching to desktop view
   * @param {Event} event - The resize event
   * @returns {void}
   */
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.checkAndCloseOnDesktop();
  }

  /**
   * Checks if the current viewport is desktop (not mobile and not tablet) and closes the dialog
   * @returns {void}
   */
  private checkAndCloseOnDesktop(): void {
    const isMobile = CommonUtils.isMobile();
    const isTablet = CommonUtils.isTablet();

    // Close dialog if not on mobile or tablet (i.e., desktop)
    if (!isMobile && !isTablet) {
      this.matDialogRef.close();
    }
  }
  /**
   * Updates the selected traveller count for the specified category and enforces the maximum total traveller rule.
   *
   * @param i The new count to set for the specified traveller category.
   * @param name The traveller category to update: 'adult', 'child', or 'infant'.
   * @returns void
   */
  toggleSelection(i?, name?: string): void {
    if (name === 'adult') {
      this.data.form.adult = i
    } else if (name === 'child') {
      this.data.form.child = i
    } else if (name === 'infant') {
      this.data.form.infant = i
    }
    const total_pax: number = this.data.form.adult + this.data.form.child + this.data.form.infant;

    if (total_pax > 9) {
      // Enforce max 9 total travellers; revert the just-changed category to a safe minimum and notify the user.
      if (name === 'adult') {
        this.data.form.adult = 1;
      } else if (name === 'child') {
        this.data.form.child = 0;
      } else if (name === 'infant') {
        this.data.form.infant = 0;
      }
      this.alertService.showToast('error', 'Maximum 9 Traveller are allowed.');
      return
    }
  }

  get CheckFareTypeValidation() {
    let isValid = this.data.form.fareType !== 'Regular' && this.data.form.fareType !== 'Armed Forces';
    if (isValid) {
      this.data.form.child = 0;
      this.data.form.infant = 0;
    }
    return isValid;
  }
}
